import { render } from "./SpecificJobs.vue?vue&type=template&id=5427bb86&scoped=true"
import script from "./SpecificJobs.vue?vue&type=script&lang=js"
export * from "./SpecificJobs.vue?vue&type=script&lang=js"

import "./SpecificJobs.vue?vue&type=style&index=0&id=5427bb86&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5427bb86"]])

export default __exports__